import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import { TimeScheduler } from '@symphona/ui-kit';
import { textFieldSx } from '@components/Checkout/steps/InstallationStep/utils/installationStepUtils';
import type { TechnicianSectionProps } from '@components/Checkout/steps/InstallationStep/InstallationStep.types';
import FormErrorMessage from '@shared/components/feedback/FormErrorMessage/FormErrorMessage';
import InfoBannerBlock from '@shared/components/feedback/InfoBannerBlock/InfoBannerBlock';
import TextFieldLabel from '@shared/components/inputs/TextFieldLabel/TextFieldLabel';

export const TechnicianSection = ({
  formik,
  schedulerValue,
  workTime,
  isSlotsLoading,
  restrictionDescription,
  onSchedulerChange,
  onDateRangeChange,
}: TechnicianSectionProps) => {
  const { values, errors, touched, setFieldValue } = formik;
  const appointmentError = touched.selectedTimeSlot && errors.selectedTimeSlot ? String(errors.selectedTimeSlot) : '';

  const handleSpecialInstructionsChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFieldValue('specialInstructions', e.target.value);
  };

  return (
    <>
      <Stack>
        <Typography variant="label.field" sx={{ lineHeight: '150%' }}>
          Schedule Technician Visit
        </Typography>
        <Typography variant="body.sm" sx={{ lineHeight: '150%' }}>
          What date do you want your service installed
        </Typography>
      </Stack>

      <Paper variant="technicianNoteBox" elevation={0}>
        <TimeScheduler
          showToggle={false}
          bookingUnit="WORK_TIME"
          workTime={workTime}
          isLoading={isSlotsLoading}
          value={schedulerValue}
          onChange={onSchedulerChange}
          onDateRangeChange={onDateRangeChange}
        />
      </Paper>

      {appointmentError && <FormErrorMessage>{appointmentError}</FormErrorMessage>}

      {restrictionDescription && (
        <InfoBannerBlock title="Important Instructions" description={restrictionDescription} />
      )}

      <Stack gap="10px">
        <TextFieldLabel label="Notes for Your Technician" optional />
        <TextField
          sx={textFieldSx}
          multiline
          rows={5}
          placeholder="Let us know anything that will help your technician find you or better understand the issue, such as buzzer number, parking instructions, best way to get a hold of you, etc."
          value={values.specialInstructions}
          onChange={handleSpecialInstructionsChange}
        />
      </Stack>
    </>
  );
};
